import { atomWithReset } from 'jotai/utils';

import type { ExamFilters } from '../../types/exam';

export const examFiltersAtom = atomWithReset<ExamFilters>({
  search: '',
  type: 'all',
  discipline: 'all',
  status: 'all',
  classRoomDisciplineStatus: 'all',
  page: 1,
  searchTrigger: 0,
});
